<template>
  <custom-popup 
    maxWidth="800px" 
    :value="value" 
    @input="$emit('input', $event)" 
    :cons="{ title: 'تمدید گروهی پکیج‌ها' }"
    :loading="btnLoading"
  >
    <div class="pa-6" id="bulk-renewal-container">
      <div class="d-flex justify-start mb-6">
          <v-chip
        v-for="(group, type) in groupedItems"
          :key="type"
          outlined
          color="primary"
        class="px-3 py-4 mx-1 rounded-lg font-weight-medium bg-white"
          >
             <v-icon left>mdi-{{ $options.filters.qrType(type, 'icon') }}</v-icon>
          <span class="mr-2 font-weight-bold">{{ $options.filters.qrType(type, 'name') }}</span>
            <v-badge
              color="primary"
            :content="group.count"
              inline
              class="mr-3 font-weight-bold"
            ></v-badge>
          </v-chip>
        </div>

      <v-form ref="form" @submit.prevent="inquirePrice">
                 <!-- انتخاب مدت زمان -->
        <p class="font-weight-bold mb-3">مدت زمان تمدید (روز):</p>
        <v-item-group v-model="form.time" mandatory @change="resetPreview">
          <v-row>
            <v-col 
              v-for="(item, index) in renewalOptions" 
              :key="item.day" 
              cols="3"
            >
              <v-item v-slot="{ active, toggle }" :value="item.day">
                <v-hover v-slot="{ hover }">
                  <v-card
                    @click="toggle"
                    :elevation="active ? 9 : (hover ? 5 : 3)"
                    :class="active ? `${item.color} lighten-4 white--text` : `${item.color}--text`"
                  class="text-center py-6 cursor-pointer rounded-xl transition-swing d-flex flex-column align-center justify-center overflow-hidden"
                    :style="[
                      active ? 'background-color: transparent !important; opacity: 0.2; border: 2px solid var(--v-primary-base); background-color: #f6f9fc;' : 'border: 2px solid #eef2f6; background-color: #ffffff;',
                      'height: 100%; position: relative;'
                    ]"
                  >
                    <div v-if="item.badge"
                    :class="active ? `${item.color} white--text` : `${item.color} lighten-3 ${item.color}--text text--darken-2`" 
                    class="text-caption px-4 py-1 font-weight-bold transition-swing" 
                    style="position: absolute; top: 0; left: 0; right: 0; margin-inline: auto; width: fit-content; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
                         
                      {{ item.badge }}
                    </div>

                    <!-- آیکون پلن -->
                    <v-icon 
                      :color="active ? item.color : 'grey lighten-1'" 
                      size="36" 
                      class="mb-2 mt-4 transition-swing"
                      :style="active ? 'transform: scale(1.15);' : ''"
                    >
                      {{ item.icon }}
                    </v-icon>

                    <!-- عدد روز -->
                    <div 
                      class="font-weight-black mb-1 transition-swing" 
                      :class="active ? 'primary--text' : 'grey--text text--darken-3'"
                      style="font-size: 3.2rem; line-height: 1;"
                    >
                      {{ persian(item.day) }}
                    </div>
                    
                    <!-- کلمه روز -->
                    <div 
                      class="text-h6 font-weight-medium transition-swing"
                      :class="active ? 'primary--text' : 'grey--text'"
                    >
                      روز
                    </div>
                    
                    <!-- تیک تایید گوشه کارت در حالت انتخاب شده -->
                    <v-scale-transition>
                      <v-icon v-if="active" :color=item.color size="28" style="position: absolute; bottom: 12px; left: 12px;">
                        mdi-check-circle
                      </v-icon>
                    </v-scale-transition>

                  </v-card>
                </v-hover>
              </v-item>
            </v-col>
          </v-row>
        </v-item-group>

        <!-- کد تخفیف -->
        <v-text-field
          v-model="form.discount"
          label="کد تخفیف (اختیاری)"
          outlined
          :disabled="previewData"
          dense
        placeholder="در صورت داشتن کد تخفیف، وارد کنید"
          color="success"
          class="mt-6"
          append-icon="mdi-ticket-percent-outline"
          @input="resetPreview"
        ></v-text-field>

        <!-- دکمه استعلام -->
        <v-btn 
          block 
          class="btn-get-code rounded-lg mt-2" 
          @click="inquirePrice" 
          :loading="btnLoading"
          v-if="!previewData"
        >
          استعلام قیمت و مشاهده پیش‌فاکتور
        </v-btn>
      </v-form>

      <!-- بخش پیش‌فاکتور (نمایش بعد از استعلام) -->
<v-expand-transition>
  <v-card v-if="previewData" outlined class="mt-6 pa-4 rounded-lg grey lighten-5">
    <h4 class="text-center mb-4 primary--text">پیش‌فاکتور تمدید</h4>
    
    <v-row dense align="center">
      <!-- تعداد کل کیوآرها -->
      <v-col cols="6" class="grey--text">تعداد کل کیوآرها:</v-col>
      <v-col cols="6" class="text-left font-weight-bold">{{ persian(previewData.count) }} عدد</v-col>

      <!-- مبلغ اولیه (نیاز است از سمت سرور پاس داده شود) -->
      <v-col v-if="previewData.basePrice" cols="6" class="grey--text">مبلغ اولیه:</v-col>
      <v-col v-if="previewData.basePrice" cols="6" class="text-left">
        {{ previewData.basePrice | currency }} ریال
      </v-col>

      <!-- درصد تخفیف بر اساس تعداد -->
      <v-col v-if="previewData.discountCount > 0" cols="6" class="orange--text text--darken-2">
        تخفیف تعدادی:
      </v-col>
      <v-col v-if="previewData.discountCount > 0" cols="6" class="text-left orange--text text--darken-2">
        {{ persian(previewData.discountCount) }}٪
      </v-col>

      <!-- درصد تخفیف کد -->
      <v-col v-if="previewData.discountCode > 0" cols="6" class="orange--text text--darken-2">
        تخفیف کد:
      </v-col>
      <v-col v-if="previewData.discountCode > 0" cols="6" class="text-left orange--text text--darken-2">
        {{ persian(previewData.discountCode) }}٪
      </v-col>

      <!-- میزان سود از خرید (مبلغ اولیه منهای مبلغ نهایی) -->
      <v-col v-if="previewData.basePrice && (previewData.basePrice - previewData.finalPrice > 0)" cols="6" class="success--text">
        سود شما از خرید:
      </v-col>
      <v-col v-if="previewData.basePrice && (previewData.basePrice - previewData.finalPrice > 0)" cols="6" class="text-left success--text font-weight-bold">
        {{ (previewData.basePrice - previewData.finalPrice) | currency }} ریال
      </v-col>

      <v-col cols="12"><v-divider class="my-2"></v-divider></v-col>

      <!-- مبلغ نهایی -->
      <v-col cols="6" class="grey--text text-subtitle-1">مبلغ نهایی:</v-col>
      <v-col cols="6" class="text-left font-weight-bold primary--text text-subtitle-1">
        <span v-if="previewData.finalPrice === 0">رایگان</span>
        <span v-else>{{ previewData.finalPrice | currency }} ریال</span>
      </v-col>

    </v-row>

    <v-btn block class="btn-get-code rounded-lg mt-4" @click="confirmRenewal" :loading="btnLoading">
      تایید و پرداخت نهایی
    </v-btn>
  </v-card>
</v-expand-transition>
    </div>
  </custom-popup>
</template>

<script>
export default {
  name: "BulkRenewalDialog",
  props: {
    value: Boolean,
    selectedItems: { type: Array, default: () => [] }
  },
  data() {
    return {
         renewalOptions: [
      { day: 30, icon: 'mdi-calendar-clock', badge: 'عادی', color: 'blue-grey' },
      { day: 90, icon: 'mdi-star-outline', badge: 'محبوب', color: 'info' },
      { day: 180, icon: 'mdi-thumb-up-outline', badge: 'پیشنهادی', color: 'success' },
      { day: 365, icon: 'mdi-crown', badge: 'باصرفه‌ترین', color: 'amber' } 
    ],
      btnLoading: false,
      previewData: null,
      form: {
        time: 30,
        discount: ''
      }
    };
  },
  computed: {
    groupedItems() {
      const groups = {};
      this.selectedItems.forEach(item => {
        if (!groups[item.type]) groups[item.type] = { count: 0 };
        groups[item.type].count++;
      });
      return groups;
    }
  },
  watch: {
    value(val) {
      if (!val) this.resetPreview();
    }
  },
  methods: {
    resetPreview() {
      this.previewData = null;
    },
    
    // استعلام قیمت (showPrice: true)
    inquirePrice() {
      this.btnLoading = true;
      const payload = {
        ids: this.selectedItems.map(i => i.id),
        time: this.form.time,
        discount: this.form.discount,
        showPrice: true
      };

      this.$api.post('v1/pre_purchase/bulkUpdate', payload)
        .then(res => {
          console.log(res.data,"data");
          this.previewData = res.data.data; // بر اساس ساختار ریسپانسی که دادید
        })
        .catch(err => {
          this.$modal.error("خطا", err.response?.data?.message || "خطا در استعلام قیمت");
        })
        .finally(() => this.btnLoading = false);
    },

    // ثبت نهایی (showPrice: false)
    confirmRenewal() {
      this.btnLoading = true;
      const payload = {
        ids: this.selectedItems.map(i => i.id),
        time: this.form.time,
        discount: this.form.discount,
        showPrice: false
      };

      this.$api.post('v1/pre_purchase/bulkUpdate', payload)
        .then(() => {
          this.$modal.success("موفق", "تمدید گروهی با موفقیت انجام شد.");
          this.$emit("success");
          this.$emit("input", false);
        })
        .catch(err => {
          this.$modal.error("خطا", err.response?.data?.message || "خطا در ثبت نهایی");
        })
        .finally(() => this.btnLoading = false);
    }
  },
  filters: {
    currency(val) {
      return parseInt(val || 0).toLocaleString('fa-IR');
    }
  }
};
</script>

<style scoped>
.cursor-pointer { cursor: pointer; }
.gap-2 { gap: 8px; }
</style>
